import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LiveDataService } from '../../../../../live-data/live-data.service';
import { catchError, filter, map, switchMap, tap } from 'rxjs/operators';
import { HallPass } from '../../../../../models/HallPass';
import { of } from 'rxjs';

import * as expiredPassesActions from '../actions';
import * as passesActions from '../../../../passes/actions';

@Injectable()
export class ExpiredPassesEffects {
	getExpiredPasses$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(
				expiredPassesActions.getExpiredPasses,
				expiredPassesActions.filterExpiredPasses,
				expiredPassesActions.getMoreExpiredPasses,
				passesActions.endPassActionSuccess
			),
			filter((action: any) => !!action.user),
			switchMap((action: any) => {
				const offset = action.offset ? action.offset : null;
				return this.liveDataService
					.watchPastHallPasses(
						action.user.roles.includes('hallpass_student') ? { type: 'student', value: action.user } : { type: 'issuer', value: action.user },
						50,
						action.timeFilter,
						offset
					)
					.pipe(
						map((expiredPasses: HallPass[]) => {
							if (offset) {
								return expiredPassesActions.getMoreExpiredPassesSuccess({ passes: expiredPasses });
							} else {
								return expiredPassesActions.getExpiredPassesSuccess({ expiredPasses });
							}
						}),
						catchError((error) => of(expiredPassesActions.getExpiredPassesFailure({ errorMessage: error.message })))
					);
			})
		);
	});

	constructor(private actions$: Actions, private liveDataService: LiveDataService) {}
}
